import { metricsFilterParams } from './constants'

export const getMetricsFilters = params => {
  return Object.fromEntries(metricsFilterParams.map(param => [param, params[param]]))
}

export const haveMetricsFiltersChanged = (appliedFilters, filters) => {
  return JSON.stringify(appliedFilters) !== JSON.stringify(filters)
}
